// 카테고리 코드/라벨 상수
export const ABTALK_CATEGORIES = [
  { code: "general", label: "자유" },
  { code: "question", label: "질문" },
  { code: "issue", label: "이슈" },
  { code: "art", label: "작품" },
  { code: "info", label: "정보" },
  { code: "news", label: "기사/뉴스" },
];

export const ANONYMOUS_CATEGORIES = [
  { code: "question", label: "질문" },
  { code: "concern", label: "고민" },
  { code: "chat", label: "잡담" },
];

// ✅ Free‑Talk 카테고리 추가
export const FREETALK_CATEGORIES = [
  { code: "column", label: "칼럼" },
  { code: "debate",  label: "토론" },
  { code: "news",    label: "전시소식" },
  { code: "info",    label: "정보" },
  { code: "issue",   label: "이슈" },
  { code: "free",   label: "자유" },

  // 필요 시 더 추가
  // { code: "review",  label: "리뷰" },
];

// board_type/카테고리 코드 → 라벨 변환
export function getCategoryLabel(boardType: string, code?: string) {
  if (!code) return "";

  // 과거 공동게시판은 고정 "자유"
  if (boardType === "공동게시판") return "자유";

  // ✅ Free‑Talk 표시
  if (
    boardType === "Free-Talk" ||
    boardType.toLowerCase() === "free-talk" ||
    boardType.toLowerCase() === "freetalk"
  ) {
    return FREETALK_CATEGORIES.find((c) => c.code === code)?.label || code;
  }

  // ABtalk 계열
  if (
    boardType.startsWith("abtalk") ||
    boardType === "artist" ||
    boardType === "worker" ||
    boardType === "fan"
  ) {
    return ABTALK_CATEGORIES.find((c) => c.code === code)?.label || code;
  }

  // 익명게시판
  if (boardType === "익명게시판") {
    return ANONYMOUS_CATEGORIES.find((c) => c.code === code)?.label || code;
  }

  return code;
}
